import { createFileRoute } from "@tanstack/react-router";
import { SEO } from "@/features/marketing/seo";
import { TimelineTool } from "@/features/marketing/tools/timeline-tool";

export const Route = createFileRoute("/_marketing/wedding-day-timeline")({
  head: SEO.dayTimeline,
  component: TimelineTool,
});
